module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":{"checkPlayer":"{players} checked in; the capacity is {capacity}.","confirm":"Are you sure to start Round {n}?"}},"ja":{"message":{"checkPlayer":"{players}がチェックインしました。定員は{capacity}人です。","confirm":"{n}回戦を開始してよろしいですか?"}}}')
  delete Component.options._Ctor
}
